<template>
  <div class="kpt-support-context-pane" :class="isCreatingTicket ? 'kpt-support-ticket-pane' : ''">
    <header class="kpt-context-pane-header">
      <h4><strong>Kymeta Support {{ isCreatingTicket ? '- Create Ticket' : '' }}</strong></h4>
      <b-icon class="has-cursor-pointer" icon="times-circle" @click.native="close"></b-icon>
    </header>
    <main id="kpt-context-pane-main">
      <div class="kpt-support-information" v-if="!isCreatingTicket">
        <div class="media">
          <figure class="media-left">
            <font-awesome-icon :icon="['far', 'user-headset']" size="4x" title="Call Us" />
          </figure>
          <div class="media-content">
            <h5 class="has-text-weight-semibold">Call Us</h5>
            <p>We are here to help, 24/7. If you require immediate assistance with a Kymeta product or service, call us at:</p>
            <p><strong>+1-855-525-6638</strong></p>
          </div>
        </div>
        <hr>
        <div class="media">
          <figure class="media-left">
            <font-awesome-icon :icon="['far', 'envelope-square']" size="4x" title="Email Us" />
          </figure>
          <div class="media-content">
            <h5 class="has-text-weight-semibold">Email Us</h5>
            <p>Send your support request to <a href="mailto:support@kymetacorp.com">support@kymetacorp.com</a> and a Kymeta support engineer will assist you as soon as possible.</p>
          </div>
        </div>
        <hr>
        <div class="media">
          <figure class="media-left">
            <font-awesome-icon :icon="['far', 'ticket-alt']" size="4x" title="Submit a Ticket" />
          </figure>
          <div id="submit-ticket" class="media-content">
            <h5 class="has-text-weight-semibold">Submit a Ticket</h5>
            <b-button type="is-outlined" class="mt-3" @click="createSupportTicket">Create Ticket</b-button>
          </div>
        </div>
      </div>
      <div class="kpt-support-create-ticket" v-else>
        <!-- Support Ticket Create -->
        <create-ticket @cancel="isCreatingTicket = false"></create-ticket>
      </div>
    </main>
  </div>
</template>
<script>
import CreateTicketComponent from '../support/components/CreateTicketComponent.vue';

export default {
  props: {
    close: Function
  },
  data() {
    return {
      isCreatingTicket: false
    }
  },
  methods: {
    createSupportTicket() {
      this.isCreatingTicket = true;
    }
  },
  components: {
    'create-ticket': CreateTicketComponent
  }
}
</script>
<style lang="scss" scoped>
@import '@/app/styles/_colors';

.kpt-support-ticket-pane {
  width: 800px !important;
}

.kpt-support-context-pane {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 515px;
  overflow-y: auto;

  // accommodate offset for lower resolutions
  @media all and (min-width: 900px) {
    height: calc(100vh - 98px);
  }

  #kpt-context-pane-main {
    padding: 20px;

    .kpt-support-information {
      .media-left {
        width: 70px;
      }
    }
  }
}
</style>
